/**
 * ReloadContext.jsx
 * @description Este cotexto es para manejar el estado de los contadores de la Main Page
 * @author Joaquin
 * @version 1.0.0
 * @date 2025-07-30
 */
import { createContext, useContext, useState } from "react";

const ReloadContext = createContext();

export const ReloadProvider = ({ children }) => {
  const [reloadKey, setReloadKey] = useState(0);
  /**
   *
   * @returns {Function} Función para disparar un reload
   * @description Esta función incrementa el estado reloadKey, lo que puede ser utilizado para cada que se crea o elimina un recurso
   */
  const triggerReload = () => setReloadKey((prev) => prev + 1); //agregar esta funcion en cada componente que necesite recargar datos en el main

  return (
    <ReloadContext.Provider value={{ reloadKey, triggerReload }}>
      {children}
    </ReloadContext.Provider>
  );
};

export const useReload = () => useContext(ReloadContext);
